import { BaseError } from '../../_base/lang/BaseError';

export class UserNotFoundError extends BaseError {
}
